// util/notify.js
import Notify from 'quasar/src/plugins/Notify.js';;

const error = (message, position) => {
    Notify.create({
        message,
        icon: 'warning',
        color: 'amber-6',
        classes: 'notify notify-error',
        progress: true,
        position, 
        actions: [
            { icon: 'close', color: 'black', round: true},
        ],
    });
};

const primary = (message, position) => {
    Notify.create({
        message,
        color: 'blue-9',
        icon: 'task_alt',
        classes: 'notify notify-primary',
        position,
        progress: true,
        actions: [
            { icon: 'close', color: 'black', round: true},
        ],
    });
};

export default {
    error,
    primary,
};